<template>
  <div id="app">
    <index></index>
  </div>
</template>

<script>
import Index from './views/Index'
export default {
  name: 'App',
  components: {
    Index
  }
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.main {
  margin: 0 auto;
  padding: 0;
}
</style>
